import * as React from 'react'
import cx from 'classnames'
import styles from './PageTip.sass'
import { EmptyState, EmptyStateIllustrationImage } from 'components/EmptyState'
import { useBrandingSettings } from 'hooks/branding'

interface PageTipProps {
  title: string
  illustrationUrl?: string
  button?: React.ReactNode
  children?: React.ReactNode
}

export default function PageTip({
  title,
  illustrationUrl,
  button,
  children,
}: PageTipProps) {
  const { corporateMode } = useBrandingSettings()

  return (
    <div className={cx(styles.root)}>
      <div className={styles.box}>
        <EmptyState
          hideIllustration={corporateMode}
          pad
          small
          title={title}
          subtitle={children}
          image={
            <EmptyStateIllustrationImage
              src={
                illustrationUrl ?? require('assets/images/img_create-job.svg')
              }
            />
          }
        >
          {button}
        </EmptyState>
      </div>
    </div>
  )
}
